import { createAction, props } from '@ngrx/store';
import { ListDTO, PaginatedReq } from '../../loading-state/api.models';
import {
  SubscriptionDTO,
  SubscriptionPlanDTO,
  SubscriptionPlanFilters,
} from '../subscription.models';

export const getSubscriptionPlans = createAction(
  '[Subscription] Get Subscription Plans',
  props<PaginatedReq<{ filters?: SubscriptionPlanFilters }>>()
);
export const setSubscriptionPlans = createAction(
  '[Subscription] Set Subscription Plans',
  props<{ subscriptionPlans: ListDTO<SubscriptionPlanDTO> | null; error?: string }>()
);

export const getSubscription = createAction('[Subscription] Get Subscription');
export const setSubscription = createAction(
  '[Subscription] Set Subscription',
  props<{ subscription: SubscriptionDTO | null; error?: string }>()
);
